import { render, staticRenderFns } from "./MainCarIcon.vue?vue&type=template&id=5a7f70cf&scoped=true&"
import script from "./MainCarIcon.vue?vue&type=script&lang=js&"
export * from "./MainCarIcon.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5a7f70cf",
  null
  ,true
)

export default component.exports